const uxInitialState = {
  language: 'ENG',
};

export default uxInitialState;
